'use strict';

var styleClasses = {"standard":"standard__1AMlX","pill-content":"pill-content__5SfzC","clickable":"clickable__II6m9","close-button":"close-button__mI5hK","small":"small__YwUMQ","medium":"medium__ZPntJ","large":"large__nTISk","xlarge":"xlarge__gjGZC","selected":"selected__-Pz9N","closeable":"closeable__LC9zp","pill-button":"pill-button__hXywh","invalid":"invalid__pXHHL","ellipsis":"ellipsis__2LsNp"};

module.exports = styleClasses;
//# sourceMappingURL=standard-pill.module.scss.js.map
